<template>
  <div :style="{opacity: opacity}">
    <slot/>
  </div>
</template>
<script>
import { MapElement } from 'vue-googlemaps'

// Those Vue props will update automatically
// (Two-way binding with .sync modifier)
const boundProps = [
  'animation',
  'clickable',
  'cursor',
  'draggable',
  // ...
]

// Events from Google Maps emitted as Vue events
const redirectedEvents = [
  'click',
  'rightclick',
  'dblclick',
  'drag',
  // ...
]

export default {
  mixins: [
    // You need to use this mixin
    MapElement,
  ],
  props: {
    offsetX: {
      type: Number,
      default: 0
    },
    offsetY: {
      type: Number,
      default: 0
    },
    alignment: {
      type: String,
      default: "top"
    },
    animation: {
			type: Number
		},
		clickable: {
			type: Boolean,
			default: true
		},
		cursor: {
			type: String
		},
		draggable: {
			type: Boolean,
			default: false
		},
		icon: {},
		label: {},
		opacity: {
			type: Number,
			default: 0.01
		},
		place: {
			type: Object
		},
		position: {
			type: Object
		},
		shape: {
			type: Object
		},
		title: {
			type: String
		},
		visible: {
			default: true
		},
		zIndex: {
			type: Number
		}
	},
  data() {
    return {
    };
  },
  // When Google Maps is ready
  googleMapsReady () {
    const options = Object.assign({}, this.$props)
    options.map = this.$_map

    // Create Google Maps objects
    this.$_marker = new window.google.maps.Marker(options)
    // Bind the Vue props
    this.bindProps(this.$_marker, boundProps)
    // Emit the events from Google Maps
    this.redirectEvents(this.$_marker, redirectedEvents)

    /* CUSTOM MARKER */
    const map = this.$_map
    const self = this
    class Overlay extends google.maps.OverlayView {
      constructor(map) {
        super();
        this.setMap(map);
        this.draw = () => this.repaint();
        this.setPosition = () => this.repaint();
      }
      repaint() {
        const div = self.$el;
        const projection = this.getProjection();
        if (projection && div) {
          const posPixel = projection.fromLatLngToDivPixel(self.latLng);
          let x, y;
          switch (self.alignment) {
            case "top":
              x = posPixel.x - div.offsetWidth / 2;
              y = posPixel.y - div.offsetHeight;
              break;
            case "bottom":
              x = posPixel.x - div.offsetWidth / 2;
              y = posPixel.y;
              break;
            case "left":
              x = posPixel.x - div.offsetWidth;
              y = posPixel.y - div.offsetHeight / 2;
              break;
            case "right":
              x = posPixel.x;
              y = posPixel.y - div.offsetHeight / 2;
              break;
            case "center":
              x = posPixel.x - div.offsetWidth / 2;
              y = posPixel.y - div.offsetHeight / 2;
              break;
            case "topleft":
            case "lefttop":
              x = posPixel.x - div.offsetWidth;
              y = posPixel.y - div.offsetHeight;
              break;
            case "topright":
            case "righttop":
              x = posPixel.x;
              y = posPixel.y - div.offsetHeight;
              break;
            case "bottomleft":
            case "leftop":
              x = posPixel.x - div.offsetWidth;
              y = posPixel.y;
              break;
            case "bottomright":
            case "rightbottom":
              x = posPixel.x;
              y = posPixel.y;
              break;
            default:
              throw new Error("Invalid alignment type of custom marker!");
              break;
          }
          div.style.left = x + self.offsetX + "px";
          div.style.top = y + self.offsetY + "px";
          div.style["z-index"] = self.zIndex + 1;
        }
      }
      onAdd() {
        const div = self.$el;
        const panes = this.getPanes();
        div.style.position = "absolute";
        div.style.display = "inline-block";
        div.style.opacity = 1;
        panes.overlayLayer.appendChild(div);
        panes.overlayMouseTarget.appendChild(div);
        this.getDraggable = () => false;
        this.getPosition = () => {
          return new google.maps.LatLng(self.lat, self.lng);
        };
      }
      onRemove() {
        self.$el.remove();
      }
    }
    this.$overlay = new Overlay(map);
    setTimeout(() => {
      if (this.$overlay) {
        this.$overlay.repaint();
      }
    }, 100);
  },

  computed: {
    lat() {
      return parseFloat(
        isNaN(this.$_marker.position.lat()) ? this.$_marker.position.lat() : this.$_marker.position.lat()
      );
    },
    lng() {
      return parseFloat(
        isNaN(this.$_marker.position.lng()) ? this.$_marker.position.lng() : this.$_marker.position.lng()
      );
    },
    latLng() {
      if (this.$_marker instanceof google.maps.LatLng) {
          return this.$_marker;
      }
      return new google.maps.LatLng(this.$_marker.position.lat(), this.$_marker.position.lng());
    }
  },

  beforeDestroy () {
    // Teardown
    if (this.$_marker) {
      this.$_marker.setMap(null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// gmap-custom-marker.vue?48c3f562